export enum FrageTherapien {
  PHYSIOTHERAPIE = 'physiotherapie',

  LOGOPAEDIE = 'logopaedie',

  ERGOTHERAPIE = 'ergotherapie',
}
